import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {environment} from "@app/environment";
import {catchError, map, Observable, of, Subject, Subscription, tap, throwError} from "rxjs";
import {plainToInstance} from "class-transformer";
import {ActivityAttachment, ActivityColumnUpdate, ActivityEvent, ActivityType} from "./datamodel";
import {DeviceService} from "../device.service";
import {UserService} from "../user.service";
import {User} from "../_datamodel/user";

@Injectable({
  providedIn: 'root',
})
export class ActivitiesService {
  options: any = {
    // withCredentials: true,
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('api-key', environment.API_KEY)
      .set('ngsw-bypass','true')
  };
  user: User | null | undefined;
  user$: Subscription;
  $updateReceived: Subject<boolean> = new Subject();

  constructor(private http: HttpClient,
              public deviceService: DeviceService,
              private userService: UserService) {
    if(!environment.production) { console.debug('Acrivities Service instanced!'); }
    this.user$ = this.userService.$user.subscribe(user => {
      this.user = user;
    })
  }

  getActivities(table?: string, fk_id?: string): Observable<ActivityEvent[]> {
    return this.http.post(environment.API_URL + '/activities/getActivities',{ table: table, fk_id: fk_id }, this.options).pipe(
      tap((data: any) => {
        if (!environment.production) console.debug('getActivities loaded:', data);
      }),
      map((data: any) => {
        // @ts-ignore
        return plainToInstance(ActivityEvent, data);
      }),
      catchError(err => {
        if (err.status === 401) {
          console.warn(err.error.message);
          return of(err);
        } else {
          return this.handleError(err);
        }
      })
    );
  }

  getActivitiesForRecord(table?: string, fk_id?: string): Observable<ActivityEvent[]> {
    return this.http.post(environment.API_URL + '/activities/getActivitiesForRecord',{ table: table, fk_id: fk_id, isAdmin: this.user?.privileges.isAdmin }, this.options).pipe(
      tap((data: any) => {
        if (!environment.production) console.debug('getActivitiesForRecord loaded:', data);
      }),
      map((data: any) => {
        // @ts-ignore
        return plainToInstance(ActivityEvent, data);
      }),
      catchError(err => {
        if (err.status === 401) {
          console.warn(err.error.message);
          return of(err);
        } else {
          return this.handleError(err);
        }
      })
    );
  }

  createActivityEvent(activity: ActivityEvent, notifyUpdate?: boolean): Observable<ActivityEvent> {
    return this.http.post(environment.API_URL + '/activities/createActivityEvent', activity, this.options).pipe(
      tap(() => {
        if (!environment.production) {
          console.debug('createActivityEvent success');
        }
        if(notifyUpdate) this.$updateReceived.next(true);
      }),
      map((data: any) => {
        // @ts-ignore
        return plainToInstance(ActivityEvent, data);
      }),
      catchError(err => {
        if (err.status === 401) {
          console.warn(err.error.message);
          return of(err);
        } else {
          return this.handleError(err);
        }
      })
    );
  }

  logActivity(type: ActivityType, table_name: string, fk_id: string, activity?: ActivityColumnUpdate | ActivityAttachment) {
    const activityEvent = new ActivityEvent();
      activityEvent.table_name = table_name;
      activityEvent.fk_id = fk_id;
      activityEvent.id_user = this.user!.user_id;
      activityEvent.c_date = new Date();
      activityEvent.activity_type = type;
      activityEvent.activity = activity;
      return this.createActivityEvent(activityEvent,true);
  }

  deleteActivityComment(activity: ActivityEvent): Observable<any> {
    return this.http.post(environment.BACKOFFICE_API_URL + '/activities/deleteActivityComment', activity, this.options).pipe(
      tap((data: any) => {
        if (!environment.production) {
          console.debug('deleteActivityComment:', data);
        }
      }),
      map((data: any) => {
        // @ts-ignore
        return plainToInstance(ActivityEvent, data);
      }),
      catchError(err => {
        if (err.status === 401) {
          console.warn(err.error.message);
          return of(err);
        } else {
          return this.handleError(err);
        }
      })
    );
  }

  private handleError(err: HttpErrorResponse) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage;
    //if (err.error instanceof Error) {
    if (err.error instanceof Error) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = err.error.message;
    }
    console.error(errorMessage);
    return throwError(() => {
      return new Error(errorMessage)
    });
  }
}
